<div class="chat-panel-wrapper">
  <style>
    .brand_tag {
      color: #0066cc;
      font-size: 1.4rem;
      font-weight: 700;
      text-decoration: none;
      font-family: cursive;
    }
  </style>
  <div class="chat-panel-header">
    <!-- <p class="alc-routing-other-user-title">{{ 'dashboardPageOtherUserTitle' | transloco }}</p> -->
    <p class="chat-panel-title"><a href="javascript:void(0);" class="brand_tag"> </a></p>
    <button
      (click)="closeModal()"
      pButton
      pRipple
      type="button"
      label="{{ 'close' | transloco }}"
      class="p-button-outlined p-button-rounded secondary-button"
      [cpakTrackClick]="ButtonNamesGA.Close"
    ></button>
  </div>
  <div class="chat-panel-block-header">
    <iframe
      allow="cookies"
      [src]="iframeUrl"
      style="min-width: 300px; width: 100%; min-height: calc(100vh - 200px); height: 100%; border: 0"
    ></iframe>
  </div>
</div>
